import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { defineComponent, inject } from 'vue';
export default defineComponent({
  props: {
    value: [String, Boolean, Number],
    checked: {
      type: Boolean,
      default: undefined
    }
  },
  emits: ['update:checked'],
  watch: {
    'context.checkedValue': function contextCheckedValue() {
      this.setChecked(this.context);
    }
  },
  data: function data() {
    return {
      sChecked: false,
      context: inject('groupContext', undefined)
    };
  },
  computed: {
    bindChecked: {
      get: function get() {
        var _this$checked;
        return (_this$checked = this.checked) !== null && _this$checked !== void 0 ? _this$checked : this.sChecked;
      },
      set: function set(val) {
        this.sChecked = val;
        this.$emit('update:checked', val);
      }
    }
  },
  created: function created() {
    var context = this.context;
    this.setChecked(context);
  },
  methods: {
    /**
     * 根据 context 设置选中状态
     * @param context
     */
    setChecked: function setChecked(context) {
      if (this.value === undefined || !context) {
        return;
      }
      var multiMode = context.multiMode,
        checkedValue = context.checkedValue;
      if (multiMode) {
        var arrayValue = checkedValue;
        this.bindChecked = arrayValue.includes(this.value);
      } else {
        this.bindChecked = checkedValue === this.value;
      }
    },
    toggle: function toggle() {
      var _this = this;
      var context = this.context,
        bindChecked = this.bindChecked;
      if (context && this.value !== undefined) {
        var group = context;
        var multiMode = context.multiMode,
          checkedValue = context.checkedValue;
        if (multiMode && this.value !== undefined) {
          var arrayValue = checkedValue;
          if (!bindChecked) {
            arrayValue.push(this.value);
            group.checkedValue = _toConsumableArray(arrayValue);
          } else {
            group.checkedValue = arrayValue.filter(function (item) {
              return item !== _this.value;
            });
          }
        } else {
          group.checkedValue = this.value;
        }
      } else if (!context) {
        this.bindChecked = !this.bindChecked;
      }
    }
  }
});